import {action, computed, makeObservable, observable, toJS} from 'mobx';
import {GeneralRequester} from "./RequestApi/GeneralRequester";
import {LoadMoreStateEnum,} from "../serverClientShared/sharedEnums";
import {generalStore, modalStore} from "../index";
import Utility from "../Utility";


export class WorkspaceManagementStore {
    editedDomain = {};
    addedProjects = new Set();
    deletedProjects = new Set();
    owner = null;
    editedOwner = null;
    isWorkspaceNew = false;
    domainProjects = [];
    subDomainProjects = [];
    subDomainProjectsMap = new Map();
    searchInput = null;
    pagination =
        {
            currentPage: 0,
            projectsPerPage: 30,
        };
    render = false;
    currentStep = 0;
    validationEditsState =
        {
            WorkspaceDisplayedName: true,
            Owner: true,
            MaxUsers: true,
            Country: true,
            ExpirationDate: true,

        };
    allDomainProjects = [];
    loadMoreState = {Modal: LoadMoreStateEnum.LOADING, View: LoadMoreStateEnum.LOADING}
    currentShiftClickProject = null;
    isSaveButtonOpen = false
    db = null;
    loading = false;
    editedSubDomainReportsSettings = null
    adminUsers = []
    disabledPermissions = false;


    constructor(generalStore, modalStore, tableStore) {
        makeObservable(this, {
            db: observable,
            loading: observable,
            editedDomain: observable,
            currentStep: observable,
            addedProjects: observable,
            deletedProjects: observable,
            owner: observable,
            editedOwner: observable,
            isWorkspaceNew: observable,
            domainProjects: observable,
            allDomainProjects: observable,
            subDomainProjects: observable,
            subDomainProjectsMap: observable,
            searchInput: observable,
            pagination: observable,
            render: observable,
            validationEditsState: observable,
            loadMoreState: observable,
            currentShiftClickProject: observable,
            isSaveButtonOpen: observable,
            editedSubDomainReportsSettings: observable,
            disabledPermissions: observable,
            adminUsers: observable,
            getCurrentColumns: computed,
            getExpirationDate: computed,
            mirroredProjectsCount: computed,
            changedMirroredProjectsCount: computed,
            isSettingsChanged: computed,
            selectAllButtonState: computed,
            handleSearchMirrorItems: action,
            handleFetchSub: action,
            handleFetchParent: action,
            handleCheckOrUncheck: action,
            isProjectChecked: action,
            handleShiftClick: action,
            handleOnConfirmEditCreateWorkspace: action,
            handleUpdateMirroredProjects: action,
            resetData: action,
            updateSubDomainSettings: action,
            handleOpenModalAction: action,
            isNameImmediateValid: action,
            isNameSavingValid: action,
            resetSearch: action,
            buildSubDomainNewReportSettings: action,
            getWorkspaceAdmins: action,


        })
        this.generalStore = generalStore;
        this.modalStore = modalStore;
        this.tableStore = tableStore;
        this.db = generalStore.workspace;
        this.buildSubDomainNewReportSettings();
    }

    get getExpirationDate() {
        if (this.editedDomain?.ExpirationDate) {
            const expirationDate = this.editedDomain.ExpirationDate;
            return expirationDate['$date'] ?? expirationDate;
        } else {
            const oneYearLater = new Date();
            oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
            return oneYearLater.toISOString().split('T')[0];
        }
    };

    isNameImmediateValid = (name) => {
        name = (name || this.editedDomain.WorkspaceDisplayedName || '')
        if (!name || name.length > 24) return false
        const validCharsRegex = /^[A-Za-z0-9 ,.\(\)\[\]:;"!?\/&*+\-_=©™®@]*$/;
        return validCharsRegex.test(name);
    }
    isNameSavingValid = (name) => {
        name = (name || this.editedDomain.WorkspaceDisplayedName || '')
            .trim()
            .replace(/\s{2,}/g, ' ');
        const alphanumericCount = (name.match(/[A-Za-z0-9]/g) || []).length;
        if (!name || name.length > 24 || alphanumericCount < 3) return false
        const validCharsRegex = /^[A-Za-z0-9 ,.\(\)\[\]:;"!?\/&*+\-_=©™®@]*$/;
        return validCharsRegex.test(name);
    }

    get isValidEmail() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(this.editedOwner);
    }

    get mirroredProjectsCount() {
        return (this.addedProjects.size - this.deletedProjects.size + this.subDomainProjectsMap.size)
    };

    get changedMirroredProjectsCount() {
        const mirrorProjectsCount = this.mirroredProjectsCount;
        const addedProjectCount = this.addedProjects.size
        const deletedProjectCount = this.deletedProjects.size
        if ((addedProjectCount === 0 && deletedProjectCount === 0) || mirrorProjectsCount <= 0) return true;
        return false

    };

    get isSettingsChanged() {
        const oldSettings = this.tableStore.currentRow
        const editableFields = ['ExpirationDate', 'MaxUsers', 'Country', 'CanMirrorParentProjects', 'CanDeleteSubWorkspace', 'CanEditExpirationDate', 'CanCallSubDomainUsers','CanCreateCustomers', 'CanAddAiChatKnowledge']
        const changed = editableFields.some(field =>
            oldSettings[field] !== this.editedDomain[field]
        );
        const isOwnerChanged = this.owner !== this.editedOwner?.toLowerCase();
        if (changed || isOwnerChanged) {
            this.isSaveButtonOpen = true
        }
        return changed || isOwnerChanged;
    }

    escapeRegex(text) {
        return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    buildBaseQuery = (skip, limit) => {
        return {
            filters: [],
            skip,
            limit,
        };
    };

    buildSubDomainQuery = (baseQuery, parentWorkspace) => {
        return {
            ...baseQuery,
            filters: [
                ...baseQuery.filters,
                {column: 'ReferencedToAnotherProject.Workspace', value: parentWorkspace, isMultipleOptions: false},
            ],
        };
    }

    buildDomainQuery = (baseQuery) => {
        return {
            ...baseQuery,
            filters: [
                ...baseQuery.filters,
                {column: 'ReferencedToAnotherProject.Workspace', value: null, isMultipleOptions: false},
            ],
        };
    }
    resetData = () => {
        this.modalStore.isCreateEditWorkspaceModalOpen = false;
        if (this.isWorkspaceNew) {
            this.isWorkspaceNew = false;
            this.subDomainProjectsMap = new Map()
            this.currentPage = 0;
            this.editedDomain = {};
            this.editedOwner = null
            this.validationEditsState =
                {
                    WorkspaceDisplayedName: true,
                    Owner: true,
                    MaxUsers: true,
                    Country: true,
                    ExpirationDate: true,

                };
            this.subDomainProjects = []
        }
        this.addedProjects = new Set()
        this.deletedProjects = new Set()


    }

    resetSearch = () =>{
        this.subDomainProjects = []
        this.currentPage = 0;
        this.searchInput = null;
        this.pagination =
            {
                currentPage: 0,
                projectsPerPage: 30,
            };

    }
    handleFetchParent = async () =>{
        const parentWorkspace = this.generalStore.domainSettings.DomainName;
        const baseQuery = this.buildBaseQuery(0, null);

        const domainQuery = this.generalStore.domainSettings.CanMirrorParentProjects
            ? baseQuery
            : this.buildDomainQuery(baseQuery);
        const domainProjects = await GeneralRequester.getParentOrSubWorkspaceProjects(parentWorkspace, domainQuery);
        this.allDomainProjects = domainProjects;
        this.domainProjects = domainProjects;
    }
    handleFetchSub = async (skip, limit) => {
        const parentWorkspace = this.generalStore.domainSettings.DomainName;
        const subWorkspace = this.isWorkspaceNew ? null : this.editedDomain.DomainName
        const baseQuery = this.buildBaseQuery(0, null);

        const subDomainQuery = this.buildSubDomainQuery(baseQuery, parentWorkspace);

        let subDomainProjects = [];
        if (subWorkspace) {
            subDomainProjects = await GeneralRequester.getParentOrSubWorkspaceProjects(subWorkspace, subDomainQuery, parentWorkspace);
        }
        this.subDomainProjects = subDomainProjects;
        const updatedSubDomainProjectsMap = new Map()
        for (const subProject of subDomainProjects) {
            updatedSubDomainProjectsMap.set(subProject.ProjectIdentifier, subProject);
        }
        this.subDomainProjectsMap = updatedSubDomainProjectsMap;

        return {subDomainProjects};
    };

    handleSearchMirrorItems = () => {
        const escapedInput = this.escapeRegex(this.searchInput);
        const searchInput = this.searchInput;

        let regex = null;

        if (searchInput.length === 1) {
            regex = new RegExp(`^${escapedInput}`, 'i');
        } else if (searchInput.length > 1) {
            regex = new RegExp(`(^|[\\s\\-_/.,()[\\]:;"!?&*+=@©™®])${escapedInput}`, 'i');
        }
        this.domainProjects = regex
            ? this.allDomainProjects.filter(project => regex.test(project.ProjectName || ''))
    : [...this.allDomainProjects];

    }
    handleCheckOrUncheck = (project, checked) => {
        if (checked) {
            if (this.subDomainProjectsMap.has(project.ProjectIdentifier)) {
                this.deletedProjects.add(project.ProjectIdentifier)
            } else {
                this.addedProjects.delete(project.ProjectIdentifier)
            }
        } else {
            if (this.subDomainProjectsMap.has(project.ProjectIdentifier)) {
                this.deletedProjects.delete(project.ProjectIdentifier)
            } else {
                this.addedProjects.add(project.ProjectIdentifier)
            }
        }
    }
    isProjectChecked = (project) => {
        const isAdded = this.addedProjects.has(project.ProjectIdentifier);
        const isInCurrentMap = this.subDomainProjectsMap.has(project.ProjectIdentifier);
        const isDeleted = this.deletedProjects.has(project.ProjectIdentifier);
        return isAdded || (isInCurrentMap && !isDeleted);
    }
    get selectAllButtonState (){
        if (this.domainProjects.length === 0) return false;
        const _added = this.addedProjects.size;
        const _deleted = this.deletedProjects.size;
        return this.domainProjects.every(project => this.isProjectChecked(project));
    }
    handleSelectOrUnselectAllMirrorProjects = (isSelect) => {
        if (this.domainProjects.length === 0) {
            return;
        }
        for (const project of this.domainProjects) {
            this.handleCheckOrUncheck(project, isSelect);
        }
        this.render = !this.render;
    }
    handleShiftClick = (index, checked) => {
        if (this.currentShiftClickProject !== null && this.currentShiftClickProject !== index) {
            const start = Math.min(this.currentShiftClickProject, index);
            const end = Math.max(this.currentShiftClickProject, index);
            for (let i = start; i <= end; i++) {
                this.handleCheckOrUncheck(this.domainProjects[i], checked);
            }
            this.render = !this.render;
            this.currentShiftClickProject = null;
        } else {
            this.currentShiftClickProject = index;
        }
    }
    handleOnConfirmEditCreateWorkspace = async () => {
        this.loading = true
        try {
            this.editedDomain.MirroredItemsCount = this.mirroredProjectsCount
            let domainName = this.editedDomain.DomainName;
            if (this.isWorkspaceNew) {
                const newEditedDomain =
                    {
                        ...toJS(this.editedDomain),
                        WorkspaceDisplayedName: this.editedDomain.WorkspaceDisplayedName.trim()
                            .replace(/\s{2,}/g, ' ')
                    }
                this.editedDomain.IsHp = this.generalStore.workspaceIsHP
                const {
                    parentDomainSettings,
                    subDomainSettings
                } = await GeneralRequester.createNewSubWorkspace(this.db, newEditedDomain, this.editedOwner.toLowerCase())
                domainName = subDomainSettings.DomainName;
                this.generalStore.domainSettings = parentDomainSettings
            }
            await this.handleUpdateMirroredProjects(domainName)
            if (!this.isWorkspaceNew){
                await this.updateSubDomainSettings(false, false)
            }
        } catch (error) {
            if (this.isWorkspaceNew) {
                modalStore.showErrorMessage('Error creating a new workspace.')
            } else {
                modalStore.showErrorMessage('Error setting new items.')
            }
        } finally {
            this.loading = false
            if (this.isWorkspaceNew){
                this.resetData()
            }
        }
    }
    handleUpdateMirroredProjects = async (SubWorkspaceName) => {
        const addedProjectList = Array.from(this.addedProjects)
        const deletedProjectList = Array.from(this.deletedProjects)
        await GeneralRequester.updateMirroredProjects(this.db, SubWorkspaceName, addedProjectList, false);
        await GeneralRequester.updateMirroredProjects(this.db, SubWorkspaceName, deletedProjectList, true);
        this.modalStore.isCreateEditWorkspaceModalOpen = false;
        this.addedProjects = new Set();
        this.deletedProjects = new Set();
        this.subDomainProjectsMap = new Map()
        this.pagination = {
            ...this.pagination,
            currentPage: 0,
        }
        await this.handleFetchSub()
        this.searchInput=''
    }
    updateSubDomainSettings = async (isWorkspaceNameChanged, addedMaxUsersChanged) => {
        const newSubDomainSettings = await GeneralRequester.updateSubWorkspaceSettings(this.db, this.editedDomain, isWorkspaceNameChanged, addedMaxUsersChanged)
        this.tableStore.currentRow = newSubDomainSettings;
        this.editedDomain = newSubDomainSettings;
    }
    handleOpenModalAction = (action) => {
        this.modalStore.modalData = {
            title: action.title,
            bodyText: action.body,
            confirmText: action.confirmText,
            cancelText: action.cancelText,
            confirmActions: action.confirmAction,
            isDelete: action.isDelete,
            goBackControl: action.goBackControl,
            extraCloseActions: action.extraCloseActions,
            isChangedColorButtons: action.isChangedColorButtons ?? false
        }
        this.modalStore.isGeneralConfirmActionDialogOpen = true;
    }
    validateEditedDomainInput = ()=> {
        const ownerValid = this.isValidEmail
        const maxUsersValid = Number.isInteger(Number(this.editedDomain.MaxUsers)) && this.editedDomain.MaxUsers > 0  && this.editedDomain.MaxUsers <= (this.generalStore.availableSeats + this.tableStore.currentRow.MaxUsers)

        if (!ownerValid || !maxUsersValid) {
            this.validationEditsState.Owner = ownerValid;
            this.validationEditsState.MaxUsers = maxUsersValid;
            return false
        }
        return true

    }
    handleSaveSettingsChangesButton = async () => {
        if (this.loading) return;
        const isNewValid = this.validateEditedDomainInput()
        if (!isNewValid) return;
        try {
            this.loading = true
            if (this.owner !== this.editedOwner.toLowerCase()) {
                const {addedMemberCount} = await GeneralRequester.transferSubWorkspaceOwnership(this.db, this.editedDomain.DomainName, this.owner, this.editedOwner.toLowerCase(), this.generalStore.workspaceIsHP)
                this.editedDomain.MembersCount += addedMemberCount;
                this.owner = this.editedOwner.toLowerCase();
                this.editedOwner = this.editedOwner.toLowerCase()
            }
            let addedMaxUsersChanged = false
            if (this.editedDomain.MaxUsers !== this.tableStore.currentRow.MaxUsers ) {
                const currentValue = this.tableStore?.currentRow?.MaxUsers ?? 0
                addedMaxUsersChanged = this.editedDomain.MaxUsers - currentValue;
            }
            await this.updateSubDomainSettings(false, addedMaxUsersChanged)
            this.generalStore.domainSettings.MembersCount += addedMaxUsersChanged;
        } catch (error) {
            this.modalStore.showErrorMessage('Error updating settings')
        } finally {
            this.loading = false;

        }
    }
    handleDeleteSubWorkspace = async () => {
        const newUpdatedParentDomainSettings = this.generalStore.domainSettings.SubDomains.filter(
            domain => domain !== this.editedDomain.DomainName
        );
        const newSetting = {...toJS(generalStore.domainSettings),SubDomains: newUpdatedParentDomainSettings};
        const updatedParentDomainSettings = await GeneralRequester.deleteSubWorkspace(this.db, this.editedDomain, newSetting)
        return updatedParentDomainSettings
    }
    handleDiscardSettingsChangesButton =() => {
        this.editedDomain = this.tableStore.currentRow;
        this.editedOwner = this.owner;
        this.validationEditsState =
            {
                WorkspaceDisplayedName: true,
                Owner: true,
                MaxUsers: true,
                Country: true,
                ExpirationDate: true,

            }
    }

    getSubWorkspaceOwner = async() =>{
        try{
            const owner = await GeneralRequester.getSubWorkspaceOwner(this.db, this.editedDomain.DomainName)
            this.owner = owner;
            this.editedOwner = owner;
        } catch (error) {
            this.modalStore.showErrorMessage('Error, current sub-workspace owner not found.')
        }
    }
    getWorkspaceAdmins = async() =>{
        try{
            const adminUsers = await GeneralRequester.getWorkspaceAdmins(this.db)
            this.adminUsers = adminUsers.map(admin => {return({label: admin.Email, value: {FullName: `${admin.Name} ${admin.LastName}`, Email:admin.Email}})})
        } catch (error) {
            this.modalStore.showErrorMessage('Error, current workspace admins not found.')
        }
    }

    memberReportColumns = [
        {header: generalStore.translate('workspace'), key: 'DomainName', width: 16, included: true},
        {header: 'Member', key: 'FullName', width: 16, included: true},
        {header: 'Member email', key: 'Email', width: 32, included: true},
        {header: 'DeviceId V10', key: 'DeviceIdV10', width: 24, included: true},
        {header: 'DeviceId V9', key: 'DeviceIdV9', width: 24, included: true},
        {header: 'Last device ID', key: 'DeviceId', width: 24, included: true},
        {header: generalStore.translate('trainingAndFieldRole'), key: 'TrainingAndFieldRole', width: 24, included: true},
        {header: generalStore.translate('contentCreatingRole'), key: 'ContentCreatingRole', width: 16, included: true},
        {header: generalStore.translate('administrationRole'), key: 'AdministrationRole', width: 16, included: true},
        {header: generalStore.translate('owner'), key: 'Owner', width: 8, included: true},
        {
            header: generalStore.translate('JoinDate'),
            key: 'DateCreated',
            width: 12,
            style: { numFmt: 'dd"."mm"."yyyy' },
            included: true
        },
        {
            header: generalStore.translate('LastActiveDate'),
            key: 'LastActive',
            width: 14,
            style: {numFmt: 'MMM. dd, yyyy'},
            included: true
        },
        {
            header: generalStore.translate('LastHeadsetLoginDate'),
            key: 'LastHeadsetLoginDate',
            width: 22,
            style: {numFmt: 'MMM. dd, yyyy'},
            included: true
        },
        {
            header: generalStore.translate('HeadsetVersion'),
            key: 'LastHeadsetVersion',
            width: 22,
            included: true
        },
        {
            header: generalStore.translate('LastPcLoginDate'),
            key: 'LastPcLoginDate',
            width: 22,
            style: {numFmt: 'MMM. dd, yyyy'},
            included: true
        },
        {
            header: generalStore.translate('pcVersion'),
            key: 'PcVersion',
            width: 22,
            included: true
        }
    ]

    subWorkspaceReportColumns = [
        {header: 'Workspace name', key: 'DomainName', width: 30, included: true},
        {header: 'Owner name:', key: 'Owner', width: 16, included: true},
        {header: 'Owner email', key: 'OwnerEmail', width: 32, included: true},
        {header: 'Number of members enabled', key: 'MaxUsers', width: 14, included: true},
        {header: 'Number of members registered', key: 'MembersCount', width: 14, included: true},
        {header: 'Active members', key: 'ActiveMembers', width: 14, included: true},
        {header: 'Expiration date', key: 'ExpirationDate', width: 12, included: true, style: {numFmt: 'MMM. dd, yyyy'},}
    ]
    buildSubDomainNewReportSettings = () => {
        if (this.generalStore.domainSettings.SubDomainReportsSettings){
            this.editedSubDomainReportsSettings = {...toJS(this.generalStore.domainSettings.SubDomainReportsSettings)}
            console.log(this.editedSubDomainReportsSettings , this.generalStore.domainSettings.SubDomainReportsSettings)
            return ;
        }
        const isHp = this.generalStore.workspaceIsHP
        this.editedSubDomainReportsSettings = {
            SubWorkspaceReportColumns: this.subWorkspaceReportColumns,
            MemberReportColumns: this.memberReportColumns.filter(col => {
                if (isHp) {
                    return col.key !== 'DeviceId';
                } else {
                    return col.key !== 'DeviceIdV10' && col.key !== 'DeviceIdV9';
                }
            }),
            AutomaticUserReport: {
                IsOn: false,
                StartDay: null,
                EndDay: null,
                EveryPeriod: 1,
                PeriodType: 2,
                AttachedUserEmail: null,
                Frequency: 1,
                DayValue: 1,
                MonthValue: 1,
                WeekValue: 0,
            }
        }
    }

    get getCurrentColumns () {
        const { MemberReportColumns, SubWorkspaceReportColumns } = this.editedSubDomainReportsSettings;
        const [currentMemberColumns, currentWorkspaceColumns] = [MemberReportColumns, SubWorkspaceReportColumns]
            .map(cols =>
                cols.filter(col => col.included).map(({ included, ...rest }) => rest)
            );
        return {currentMemberColumns, currentWorkspaceColumns}
    }

    downloadUserReport = async () => {
        if (this.loading) return;
        try {
            this.loading = true
            const {currentMemberColumns, currentWorkspaceColumns} = this.getCurrentColumns;
            if (currentWorkspaceColumns.length === 0 && currentMemberColumns.length === 0) {
                this.modalStore.showErrorMessage('At least one field is required to generate the report.')
                return;
            }
            const {worksheets, fileName} = await GeneralRequester.generateSubWorkspaceReport(this.db, currentMemberColumns, currentWorkspaceColumns);
            await Utility.downloadExcel(worksheets, fileName);
        } catch (error) {
            this.modalStore.showErrorMessage('Error generating report')
        } finally {
            this.loading = false;
        }
    }

    saveSubWorkspaceReportsSettings =  async ()=> {
        if (this.loading) return;
        try {
            this.loading = true
            const newDomainSettings = {...toJS(this.generalStore.domainSettings) ,SubDomainReportsSettings: {...toJS(this.editedSubDomainReportsSettings)}}
            await GeneralRequester.saveSubWorkspaceReportSettings(this.db, newDomainSettings)
            this.generalStore.domainSettings = newDomainSettings
        } catch (error) {
            this.modalStore.showErrorMessage('Error saving report settings')
        } finally {
            this.loading = false;
        }
    }


}